export default __webpack_public_path__ + "static/media/mf-m-min-logo.73353233.svg";